import { render, staticRenderFns } from "./CourseStart.vue?vue&type=template&id=67ebdfce&scoped=true&"
import script from "./CourseStart.vue?vue&type=script&lang=js&"
export * from "./CourseStart.vue?vue&type=script&lang=js&"
import style0 from "./CourseStart.vue?vue&type=style&index=0&id=67ebdfce&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ebdfce",
  null
  
)

export default component.exports